import Confirmation from "./Confirmation";
import CreateBooking from "./CreateBooking";
import UploadDocs from "./UploadDocs/UploadDocs";
import { useDispatch } from "react-redux";
import { PAGES } from "./CreateBookingWrapper";

export interface PagerProps {
  page: PAGES;
  cancel: Function;
}

const Pager = (props: PagerProps) => {
  const dispatch = useDispatch();

  switch (props.page) {
    case PAGES.CreateBooking:
      return <CreateBooking />;
    case PAGES.UploadSupportingDocs:
      return <UploadDocs />;
    case PAGES.Confirmation:
      return <Confirmation />;
    default: {
      dispatch(props.cancel());
      return null;
    }
  }
};

export default Pager;
